import { type UserRole } from '@@auth/constants';
import { isAuthorized } from '@@auth/utils/isAuthorized';
import { useAuthStore } from '@@scripts/store/useAuthStore';
import { selectSmartUserRole, useDevToolbarStore } from '@@scripts/store/useDevToolbarStore';

export class ForbiddenError extends Error {
    constructor() {
        super('Forbidden');
        this.name = 'ForbiddenError';
    }
}

/**
 * A section's `beforeLoad`. Other roles get the 403 page in place of the section, at the URL they
 * asked for. No roles let everyone in, as for the navigation items without `authorize`.
 *
 * @example
 * export const Route = createFileRoute('/_authenticated/users')({
 *     beforeLoad: requireRoles(config.navigation.users.authorize),
 * });
 */
export const requireRoles = (roles: UserRole[] | undefined) => () => {
    // The developer toolbar's role wins, as in `useAuthorization`
    const userRole =
        selectSmartUserRole(useDevToolbarStore.getState()) || useAuthStore.getState().userRole;

    if (!isAuthorized(userRole, roles)) {
        throw new ForbiddenError();
    }
};
